/* Estratto da snippets/ames-consent.liquid.
   Stava dentro l'HTML di ogni pagina: 5 KB non memorizzabili in cache,
   riscaricati e rianalizzati a ogni visita. Qui ha un indirizzo, quindi
   il browser lo prende una volta sola. Non contiene Liquid: le stringhe
   tradotte e gli indirizzi degli asset arrivano da variabili globali
   definite in layout/theme.liquid. */
(function () {
  'use strict';
  var box = document.querySelector('[data-consent]');
  if (!box) return;

  var prefs   = box.querySelector('[data-consent-prefs]');
  var btnSave = box.querySelector('[data-consent-action="save"]');
  var btnCust = box.querySelector('[data-consent-action="customize"]');

  function show(){ box.hidden = false; requestAnimationFrame(function(){ box.classList.add('is-in'); }); }
  function hide(){
    box.classList.remove('is-in');
    setTimeout(function(){ box.hidden = true; }, 260);
  }

  function apply(consent, done){
    try {
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics:     !!consent.analytics,
        marketing:     !!consent.marketing,
        preferences:   !!consent.preferences,
        sale_of_data:  !!consent.marketing
      }, function(){ if (done) done(); });
    } catch (e) { if (done) done(); }
  }

  function chosen(){
    var out = { analytics: false, marketing: false, preferences: false };
    box.querySelectorAll('[data-consent-cat]').forEach(function (cb) {
      out[cb.getAttribute('data-consent-cat')] = cb.checked;
    });
    return out;
  }

  box.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-consent-action]');
    if (!btn) return;
    var action = btn.getAttribute('data-consent-action');

    if (action === 'customize'){
      prefs.hidden = false;
      btnCust.hidden = true;
      btnSave.hidden = false;
      return;
    }
    /* Il segno locale si scrive per ogni scelta, rifiuto compreso. Chi rifiuta
       ha scelto quanto chi accetta e il banner non deve tornare, ma dopo un
       rifiuto currentVisitorConsent() e' tutto "no": da sola quella lettura non
       distingue "ha detto no" da "non ha ancora risposto". */
    if (action === 'accept')  return apply({ analytics: true,  marketing: true,  preferences: true },  function(){ scriviSegno(); hide(); });
    if (action === 'reject')  return apply({ analytics: false, marketing: false, preferences: false }, function(){ scriviSegno(); hide(); });
    if (action === 'save')    return apply(chosen(), function(){ scriviSegno(); hide(); });
  });

  /* Riapertura dalle preferenze (link nel footer / policy) */
  window.AMES_CONSENT = {
    open: function () {
      prefs.hidden = false;
      btnCust.hidden = true;
      btnSave.hidden = false;
      try {
        var c = window.Shopify.customerPrivacy.currentVisitorConsent();
        box.querySelectorAll('[data-consent-cat]').forEach(function (cb) {
          cb.checked = c[cb.getAttribute('data-consent-cat')] === 'yes';
        });
      } catch (e) {}
      show();
      /* Aperto da "Preferenze cookie" il pannello compariva in fondo alla
         pagina ma il fuoco restava sul link del piede: da tastiera o con lo
         screen reader non si arrivava alle caselle. */
      var primo = box.querySelector('[data-consent-cat]');
      if (primo) setTimeout(function(){ try { primo.focus({ preventScroll: true }); } catch (e) {} }, 60);
    }
  };
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-consent]')) {
      e.preventDefault();
      window.AMES_CONSENT.open();
    }
  });

  /* Perche' non aspettiamo loadFeatures per dipingere.
     Aspettare la Customer Privacy API significava dipingere il banner a ~6,3 s su
     mobile lento: essendo il blocco di testo piu' grande della pagina, il testo dei
     cookie diventava l'elemento LCP dell'INTERO sito (LCP misurato 7,0 s su
     collezione). Ed e' anche un consenso peggiore: la richiesta arrivava addosso a
     chi aveva gia' iniziato a leggere.
     Ora: se non c'e' gia' una scelta registrata (cookie _tracking_consent, leggibile
     senza rete) il banner si dipinge subito; quando l'API risponde, se per la regione
     del visitatore il banner non serve, lo richiudiamo. */
  var btnMore = box.querySelector('[data-consent-more]');
  if (btnMore) btnMore.addEventListener('click', function(){
    var open = box.classList.toggle('is-more');
    btnMore.setAttribute('aria-expanded', open ? 'true' : 'false');
    btnMore.textContent = open ? btnMore.getAttribute('data-less') : btnMore.getAttribute('data-more');
  });

  /* Come si capisce se il visitatore ha gia' scelto.

     Prima si guardavano il cookie `_tracking_consent` e `shouldShowBanner()`.
     Su questo negozio il cookie non viene mai scritto e shouldShowBanner()
     resta true anche dopo la scelta: il banner tornava a ogni pagina. Il
     consenso pero' e' registrato davvero — currentVisitorConsent() risponde
     "yes" e sopravvive alla navigazione.

     Quindi: un segno in localStorage, scritto al momento della scelta, che si
     legge subito e senza rete (serve a non far lampeggiare il banner sul primo
     disegno); e, appena l'API risponde, il consenso registrato, che copre anche
     chi aveva scelto prima di questa correzione o da un altro punto del sito. */
  var CHIAVE = 'ames_consenso';

  function segnoLocale(){
    try { return !!localStorage.getItem(CHIAVE); } catch (e) { return false; }
  }
  function scriviSegno(){
    try { localStorage.setItem(CHIAVE, '1'); } catch (e) {}
  }
  function consensoRegistrato(){
    try {
      var c = window.Shopify.customerPrivacy.currentVisitorConsent();
      return !!(c && (c.analytics || c.marketing || c.preferences || c.sale_of_data));
    } catch (e) { return false; }
  }
  function hasChoice(){
    return segnoLocale() ||
           document.cookie.indexOf('_tracking_consent=') !== -1;
  }

  function boot(){
    try {
      if (consensoRegistrato()) { scriviSegno(); hide(); return; }
      if (segnoLocale()) { hide(); return; }
      if (window.Shopify.customerPrivacy.shouldShowBanner()) { show(); }
      else { hide(); }
    } catch (e) {}
  }

  if (!hasChoice()) show();

  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (!err) boot();
    });
  }
})();
